<template>
  <div>
    <HeroBanner :page="'about'"/>
    <div class="container">
      <section class="about">
        <p>
          {{ $t('pages.about.content.welcome') }}
          <br><br>
          {{ $t('pages.about.content.presentation') }}
        </p>
      </section>
      <section class="creators">
        <div class="columns is-variable is-8">
          <AboutCard
            :image="'https://www.campus-booster.net/actorpictures/170683.jpg'"
            :name="'Alexis Perret'"
            :username="'alecise'"
            :description="$t('pages.about.content.founders.alexis')"
            :website="'https://t.me/Alecise'"
          />
          <AboutCard
            :image="'https://www.campus-booster.net/actorpictures/172586.jpg'"
            :name="'Thomas Mausset'"
            :username="'groff'"
            :description="$t('pages.about.content.founders.thomas')"
            :website="'https://t.me/hisgr'"
          />
          <AboutCard
            :image="'https://www.campus-booster.net/actorpictures/172969.jpg'"
            :name="'Victor Nougmanov'"
            :username="'le_visue'"
            :description="$t('pages.about.content.founders.victor')"
            :website="'https://t.me/impakter'"
          />
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import HeroBanner from '@/components/HeroBanner'
import AboutCard from '@/components/AboutCard'
export default {
  components: {
    HeroBanner,
    AboutCard
  }
}
</script>

<style scoped>
.about {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/PageAbout.vue